import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Button,
  message,
  Popconfirm,
  Skeleton,
  Space,
  Table,
} from "antd";
import type { ColumnsType } from "antd/es/table";
import { DeleteOutlined } from "@ant-design/icons";
import AddAdministrator from "./AddAdministrator";
import EditAdministrator from "./EditAdministrator";
import axiosConfig from "../../../util/axiosConfig";
import { Link } from "react-router-dom";
import requestErrorHandler from "../../../util/requestErrorHandler";

interface AdministratorsType {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

const Administrators = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [page] = React.useState(1);
  const [paginationSize] = useState(10);
  const [administrators, setAdministrators] = useState<AdministratorsType[]>(
    []
  );

  const columns: ColumnsType<AdministratorsType> = [
    {
      title: "#",
      dataIndex: "id",
      render: (_, record, index) => (page - 1) * paginationSize + index + 1,
    },
    {
      title: "Name",
      dataIndex: "lastName",
      key: "lastName",
      render: (_, record, index) => (
        <div>{record.firstName + " " + record.lastName}</div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record: AdministratorsType) => (
        <Space size="middle">
          <EditAdministrator
            admin={record}
            getAdministrators={getAdministrators}
          />
          <Popconfirm
            title={`Are you sure you want to delete ${record.firstName} admin?`}
            onConfirm={() => {
              handleDelete(record.id);
            }}
            okText="Delete"
            cancelText="Cancel"
          >
            <Button type="primary" danger>
              <DeleteOutlined />
              <span className="">Delete</span>
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  async function getAdministrators() {
    setIsLoading(true);
    await axiosConfig
      .get("admin/getall")
      .then((response: any) => {
        setAdministrators(response.data.data);
      })
      .catch((error) => {
        requestErrorHandler(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  async function handleDelete(id: any) {
    await axiosConfig
      .delete(`/admin/delete?adminId=${id}`)
      .then((response: any) => {
        message.success("Admin deleted successfully");
        getAdministrators();
      })
      .catch((error) => {
        requestErrorHandler(error);
      });
  }

  useEffect(() => {
    getAdministrators();
  }, []);

  return (
    <div>
      <div className="flex items-center justify-between">
        <div className="my-8">
          <h2 className="text-lg font-semibold">Administrators</h2>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to={"/admin"}>Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Administrators</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div>
          <AddAdministrator getAdministrators={getAdministrators} />
        </div>
      </div>
      <div className="site-layout-background w-full overflow-auto bg-white">
        {isLoading ? (
          <Skeleton active paragraph={{ rows: 8 }} />
        ) : (
          <Table columns={columns} dataSource={administrators} rowKey="id" />
        )}
      </div>
    </div>
  );
};

export default Administrators;
